<template>
  <div class="snack-bar-holder">
    <div class="snack-message">{{ getSnackMessage }}</div>
    <div class="dismiss-btn" @click="hideSnack">DISMISS</div>
  </div>
</template>

<script>
import {useModalStore} from '@/store/ModalStore';

export default {
  name: 'SnackBar',
  setup () {
    const modalStore = useModalStore();
    return {
      modalStore
    };
  },
  computed : {
    getSnackMessage () {
      return this.modalStore.message;
    }
  },
  methods: {
    hideSnack () {
      this.modalStore.hideModal();
    }
  }
};
</script>

<style scoped>
.snack-bar-holder {
  background-color: var(--nelson-green);
  align-self: flex-end;
  min-width: 400px;
  color: white;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin: 10px 10px 50px;
  pointer-events: auto;
  align-content: center;
}

.dismiss-btn {
  font-size: .85em;
  font-weight: bold;
  cursor: pointer;
  padding-top: 3px;
  margin-right: 10px;
}

.snack-message {
  margin-left: 10px;
  font-size: .88em;
  padding-top: 3px;
}
</style>